import { atom } from 'recoil';

export const siteHeaderShouldBeInModalOverlay = atom<boolean>({
  key: 'siteHeaderShouldBeInModalOverlay',
  default: false,
});
